import React, { useEffect } from 'react';
import { Hero } from './components/landing/Hero';
import { ForYouSection } from './components/landing/ForYouSection';
import { ProblemSection } from './components/landing/ProblemSection';
import { SolutionSection } from './components/landing/SolutionSection';
import { TransformationSection } from './components/landing/TransformationSection';
import { IncludesSection } from './components/landing/IncludesSection';
import { FAQSection } from './components/landing/FAQSection';
import { FinalCTA } from './components/landing/FinalCTA';
import { Footer } from './components/landing/Footer';
import { SalesNotification } from './components/ui/SalesNotification';
import { initMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel (includes PageView tracking)
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-[#FDFCF8] font-sans text-stone-900 selection:bg-emerald-100 selection:text-emerald-900" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <ForYouSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <TransformationSection data-id="element-6" />
        <IncludesSection data-id="element-7" />
        <FAQSection data-id="element-8" />
        <FinalCTA data-id="element-9" />
      </main>

      <Footer data-id="element-10" />
      <SalesNotification data-id="element-11" />
    </div>;
}